import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog/dialog.service';
import { Router } from '@angular/router';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-family-list-item',
  templateUrl: './family-list-item.component.html',
  styleUrls: ['./family-list-item.component.scss'],
})
/**
 * Family List Component
 */
export class FamilyListItemComponent {
  @Input() familyData: any;
  @Input() vipConfigSeriesData: any;
  @Output() requestRefresh = new EventEmitter<void>();

  /**
   * @constructor
   */
  constructor(private dialogService: DialogService, private router: Router) {}

  /**
   * Open Family Form Modal dialog in Edit Family mode
   * @param {Event} event
   */
  openEditFamilyModal(event: Event): void {
    (event.currentTarget as HTMLElement).blur();
    this.router.navigate([RoutesKeys.VIP_SETTINGS_DETAIL, this.familyData.id]);
  }

  /**
   * Open promotional Modal dialog
   * @param {Event} event
   */
  openEditPromoTextModal(event: Event): void {
    (event.currentTarget as HTMLElement).blur();
    this.vipConfigSeriesData.familyId = this.familyData.id;
    this.dialogService.openPromoTextModal(this.vipConfigSeriesData, () => {
      this.requestRefresh.emit();
    });
  }
}
